import { getItemDef } from "../sim/items";
import type { SpaceItem } from "../sim/types";
import { classifyItem, pushItemDot, type ViewLod } from "./lod";
import type { Renderer } from "./renderer";

export function pushItemTiles(r: Renderer, items: Iterable<SpaceItem>, view?: ViewLod): void {
  for (const it of items) {
    let dotAlpha = 0;
    if (view) {
      const lod = classifyItem(view, it);
      if (lod.cull) continue;
      if (!lod.full) { pushItemDot(r, it, view, lod.dotAlpha); continue; }
      dotAlpha = lod.dotAlpha;
    }
    const def = getItemDef(it.defId);
    const uv = r.atlas.lookup.get(def.sprite);
    if (uv) {
      const destroyed = it.hp <= 0;
      r.pushTileRaw(
        it.pos.x, it.pos.y,
        def.sizeM, def.sizeM,
        it.rot, destroyed ? 2 : 0,
        uv.u, uv.v, uv.w, uv.h,
        destroyed ? 0 : it.tempK,
        0, def.stats.thermalEmissivity,
        it.vel.x, it.vel.y, it.angVel,
      );
    }
    // Cross-fade: dot rides on top of the still-drawn silhouette.
    if (dotAlpha > 0 && view) pushItemDot(r, it, view, dotAlpha);
  }
}
